import { useSearchParams } from 'next/navigation'

import { GENERATOR_SEARCH_PARAM } from '../generatorTypes'

export const useGeneratorSearchParam = (param: GENERATOR_SEARCH_PARAM) =>
	useSearchParams().get(param)
